// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27%3E%3Cpath d=%27M0 0l6 8 6-8z%27 fill=%27%2398a2b3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RegisterUser.module.css */

.RegisterUser_page__RTER1 {
  min-height: 100vh;
  background-color: #f0f4f8;
  padding-top: 64px;
}

/* ── Header ── */
.RegisterUser_pageHeader__xiBFL {
  background: #ffffff;
  border-bottom: 1px solid #e4e7ec;
  padding: 16px 20px;
}

.RegisterUser_headerInner__V9JH5 {
  max-width: 900px;
  margin: 0 auto;
}

.RegisterUser_breadcrumb__8y0Ac {
  font-size: 13px;
  color: #98a2b3;
  margin-bottom: 8px;
}

.RegisterUser_breadcrumb__8y0Ac a {
  color: #98a2b3;
  text-decoration: none;
}

.RegisterUser_breadcrumb__8y0Ac span {
  color: #344054;
  font-weight: 500;
}

.RegisterUser_headerRow__jY2Gy {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.RegisterUser_headerLeft__bnQiS h1 {
  font-size: 1.9rem;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0 0 4px;
}

.RegisterUser_headerLeft__bnQiS p {
  font-size: 14px;
  color: #667085;
  margin: 0;
}

.RegisterUser_loginHint__jTE5D {
  font-size: 14px;
  color: #667085;
  white-space: nowrap;
}

.RegisterUser_loginHint__jTE5D a {
  color: #1a3a5c;
  font-weight: 600;
  text-decoration: none;
}

.RegisterUser_loginHint__jTE5D a:hover {
  text-decoration: underline;
}

/* ── Contenido ── */
.RegisterUser_content__PMnsB {
  max-width: 900px;
  margin: 36px auto;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Cards ── */
.RegisterUser_card__Wm-oh {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 32px 36px;
  box-sizing: border-box;
}

.RegisterUser_stepLabel__WtYvw {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 4px;
}

.RegisterUser_cardTitle__a5yoS {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 24px;
}

.RegisterUser_cardTitleRow__G9Shg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.RegisterUser_cardTitleRow__G9Shg .RegisterUser_cardTitle__a5yoS {
  margin-bottom: 0;
}

/* ── Grids ── */
.RegisterUser_formGrid__T\\+dfE {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 14px;
  margin-bottom: 0;
}

/* ── Inputs ── */
.RegisterUser_field__5viwc {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.RegisterUser_label__369rd {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #667085;
}

.RegisterUser_input__Rl4Of {
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
  font-family: inherit;
}

.RegisterUser_input__Rl4Of:focus {
  border-color: #1a3a5c;
}

.RegisterUser_input__Rl4Of::placeholder {
  color: #b0b8c4;
}

.RegisterUser_select__3Q21h {
  height: 40px;
  padding: 0 10px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 12px center;
  appearance: none;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s;
  font-family: inherit;
}

.RegisterUser_select__3Q21h:focus {
  border-color: #1a3a5c;
}

/* ── Password ── */
.RegisterUser_passwordWrap__CYxDc {
  position: relative;
}

.RegisterUser_passwordWrap__CYxDc .RegisterUser_input__Rl4Of {
  padding-right: 40px;
}

.RegisterUser_eyeBtn__bMkkC {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #98a2b3;
  padding: 0;
  display: flex;
  align-items: center;
}

/* ── Botón agregar dependiente ── */
.RegisterUser_btnAddDependent__gCljD {
  padding: 8px 18px;
  background: transparent;
  border: 1.5px solid #2db899;
  border-radius: 8px;
  color: #2db899;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.RegisterUser_btnAddDependent__gCljD:hover {
  background: #e6f7f3;
}

/* ── Estado vacío dependientes ── */
.RegisterUser_emptyDependents__pV7fJ {
  background: #f8fafc;
  border: 1.5px dashed #d0d5dd;
  border-radius: 10px;
  padding: 24px 20px;
  text-align: center;
  color: #98a2b3;
  font-size: 14px;
}

/* ── Card de dependiente ── */
.RegisterUser_dependentCard__beoUA {
  border: 1.5px solid #e4e7ec;
  border-radius: 10px;
  padding: 16px 20px 20px;
  margin-bottom: 16px;
}

.RegisterUser_dependentCard__beoUA:last-child {
  margin-bottom: 0;
}

.RegisterUser_dependentHeader__5zWDj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.RegisterUser_dependentTitle__dOvhB {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #344054;
}

.RegisterUser_dependentNum__t1Wk9 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1a3a5c;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.RegisterUser_btnRemove__gJkRH {
  padding: 5px 12px;
  background: transparent;
  border: 1.5px solid #fda29b;
  border-radius: 6px;
  color: #d92d20;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.2s;
}

.RegisterUser_btnRemove__gJkRH:hover {
  background: #fff1f0;
}

.RegisterUser_dependentGrid__-\\+qQB {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}

/* ── Card de términos + submit ── */
.RegisterUser_footerCard__EDj4a {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.RegisterUser_checkRow__hXMH5 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #344054;
}

.RegisterUser_checkRow__hXMH5 input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2db899;
  cursor: pointer;
  flex-shrink: 0;
}

.RegisterUser_checkRow__hXMH5 a {
  color: #2db899;
  font-weight: 600;
  text-decoration: none;
}

.RegisterUser_btnSubmit__AZ7d4 {
  padding: 11px 36px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.RegisterUser_btnSubmit__AZ7d4:hover {
  background: #25a085;
}

.RegisterUser_btnSubmit__AZ7d4:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #2db899;
}

.RegisterUser_inputError__WIDoD {
  border-color: #e53e3e !important;
  background: #fff5f5;
}

.RegisterUser_errorMsg__0gNtV {
  display: block;
  color: #e53e3e;
  font-size: 11px;
  margin-top: 3px;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .RegisterUser_formGrid__T\\+dfE {
    grid-template-columns: repeat(2, 1fr);
  }

  .RegisterUser_dependentGrid__-\\+qQB {
    grid-template-columns: repeat(2, 1fr);
  }

  .RegisterUser_card__Wm-oh {
    padding: 24px 20px;
  }

  .RegisterUser_footerCard__EDj4a {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .RegisterUser_btnSubmit__AZ7d4 {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .RegisterUser_formGrid__T\\+dfE,
  .RegisterUser_dependentGrid__-\\+qQB {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RegisterUser/RegisterUser.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;+BAE6B;EAE7B,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* RegisterUser.module.css */\n\n.page {\n  min-height: 100vh;\n  background-color: #f0f4f8;\n  padding-top: 64px;\n}\n\n/* ── Header ── */\n.pageHeader {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e7ec;\n  padding: 16px 20px;\n}\n\n.headerInner {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.breadcrumb {\n  font-size: 13px;\n  color: #98a2b3;\n  margin-bottom: 8px;\n}\n\n.breadcrumb a {\n  color: #98a2b3;\n  text-decoration: none;\n}\n\n.breadcrumb span {\n  color: #344054;\n  font-weight: 500;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.headerLeft h1 {\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0 0 4px;\n}\n\n.headerLeft p {\n  font-size: 14px;\n  color: #667085;\n  margin: 0;\n}\n\n.loginHint {\n  font-size: 14px;\n  color: #667085;\n  white-space: nowrap;\n}\n\n.loginHint a {\n  color: #1a3a5c;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.loginHint a:hover {\n  text-decoration: underline;\n}\n\n/* ── Contenido ── */\n.content {\n  max-width: 900px;\n  margin: 36px auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Cards ── */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);\n  padding: 32px 36px;\n  box-sizing: border-box;\n}\n\n.stepLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 4px;\n}\n\n.cardTitle {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 24px;\n}\n\n.cardTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.cardTitleRow .cardTitle {\n  margin-bottom: 0;\n}\n\n/* ── Grids ── */\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 0;\n}\n\n/* ── Inputs ── */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #667085;\n}\n\n.input {\n  height: 40px;\n  padding: 0 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.input::placeholder {\n  color: #b0b8c4;\n}\n\n.select {\n  height: 40px;\n  padding: 0 10px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff\n    url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M0 0l6 8 6-8z' fill='%2398a2b3'/%3E%3C/svg%3E\")\n    no-repeat right 12px center;\n  -webkit-appearance: none;\n  appearance: none;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.select:focus {\n  border-color: #1a3a5c;\n}\n\n/* ── Password ── */\n.passwordWrap {\n  position: relative;\n}\n\n.passwordWrap .input {\n  padding-right: 40px;\n}\n\n.eyeBtn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #98a2b3;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Botón agregar dependiente ── */\n.btnAddDependent {\n  padding: 8px 18px;\n  background: transparent;\n  border: 1.5px solid #2db899;\n  border-radius: 8px;\n  color: #2db899;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.btnAddDependent:hover {\n  background: #e6f7f3;\n}\n\n/* ── Estado vacío dependientes ── */\n.emptyDependents {\n  background: #f8fafc;\n  border: 1.5px dashed #d0d5dd;\n  border-radius: 10px;\n  padding: 24px 20px;\n  text-align: center;\n  color: #98a2b3;\n  font-size: 14px;\n}\n\n/* ── Card de dependiente ── */\n.dependentCard {\n  border: 1.5px solid #e4e7ec;\n  border-radius: 10px;\n  padding: 16px 20px 20px;\n  margin-bottom: 16px;\n}\n\n.dependentCard:last-child {\n  margin-bottom: 0;\n}\n\n.dependentHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.dependentTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #344054;\n}\n\n.dependentNum {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.btnRemove {\n  padding: 5px 12px;\n  background: transparent;\n  border: 1.5px solid #fda29b;\n  border-radius: 6px;\n  color: #d92d20;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: background-color 0.2s;\n}\n\n.btnRemove:hover {\n  background: #fff1f0;\n}\n\n.dependentGrid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n}\n\n/* ── Card de términos + submit ── */\n.footerCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #344054;\n}\n\n.checkRow input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2db899;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.checkRow a {\n  color: #2db899;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.btnSubmit {\n  padding: 11px 36px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.btnSubmit:hover {\n  background: #25a085;\n}\n\n.btnSubmit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: #2db899;\n}\n\n.inputError {\n  border-color: #e53e3e !important;\n  background: #fff5f5;\n}\n\n.errorMsg {\n  display: block;\n  color: #e53e3e;\n  font-size: 11px;\n  margin-top: 3px;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .formGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .dependentGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card {\n    padding: 24px 20px;\n  }\n\n  .footerCard {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n\n  .btnSubmit {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .formGrid,\n  .dependentGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `RegisterUser_page__RTER1`,
	"pageHeader": `RegisterUser_pageHeader__xiBFL`,
	"headerInner": `RegisterUser_headerInner__V9JH5`,
	"breadcrumb": `RegisterUser_breadcrumb__8y0Ac`,
	"headerRow": `RegisterUser_headerRow__jY2Gy`,
	"headerLeft": `RegisterUser_headerLeft__bnQiS`,
	"loginHint": `RegisterUser_loginHint__jTE5D`,
	"content": `RegisterUser_content__PMnsB`,
	"card": `RegisterUser_card__Wm-oh`,
	"stepLabel": `RegisterUser_stepLabel__WtYvw`,
	"cardTitle": `RegisterUser_cardTitle__a5yoS`,
	"cardTitleRow": `RegisterUser_cardTitleRow__G9Shg`,
	"formGrid": `RegisterUser_formGrid__T+dfE`,
	"field": `RegisterUser_field__5viwc`,
	"label": `RegisterUser_label__369rd`,
	"input": `RegisterUser_input__Rl4Of`,
	"select": `RegisterUser_select__3Q21h`,
	"passwordWrap": `RegisterUser_passwordWrap__CYxDc`,
	"eyeBtn": `RegisterUser_eyeBtn__bMkkC`,
	"btnAddDependent": `RegisterUser_btnAddDependent__gCljD`,
	"emptyDependents": `RegisterUser_emptyDependents__pV7fJ`,
	"dependentCard": `RegisterUser_dependentCard__beoUA`,
	"dependentHeader": `RegisterUser_dependentHeader__5zWDj`,
	"dependentTitle": `RegisterUser_dependentTitle__dOvhB`,
	"dependentNum": `RegisterUser_dependentNum__t1Wk9`,
	"btnRemove": `RegisterUser_btnRemove__gJkRH`,
	"dependentGrid": `RegisterUser_dependentGrid__-+qQB`,
	"footerCard": `RegisterUser_footerCard__EDj4a`,
	"checkRow": `RegisterUser_checkRow__hXMH5`,
	"btnSubmit": `RegisterUser_btnSubmit__AZ7d4`,
	"inputError": `RegisterUser_inputError__WIDoD`,
	"errorMsg": `RegisterUser_errorMsg__0gNtV`
};
export default ___CSS_LOADER_EXPORT___;
